<template>
    <section class="login-form">
        <div class="container-fluid" v-if="!isEmailExist">
            <div class="row">

                <div class="col-lg-6 col-md-12 col-sm-12">
                    <div class="login-form-img">
                        <img :src="forgetPasswordPageImg" alt="login form img" />
                    </div>
                </div>

                <div class="col-lg-6 col-md-12 col-sm-12">

                    <div class="login-form-inputs">
                        <a class="back-btn" :href="loginPageUrl">
                            <img src="../../../Assets/Images/arrow-left.png" alt="Arrow" /> <span>{{ backBtn }}</span>
                        </a>
                        <div class="login-form-logo">
                            <img src="../../../Assets/Images/logo-login.png" alt="EDA logo" />
                        </div>
                        <h3 class="generic-description">{{ forgetPasswordPageTitle }}</h3>
                        <p class="input-ask">{{ forgetPasswordEmailConfirmation }}</p>
                        <form v-on:submit.prevent="onSubmit" class="form-container">
                            <div class="input-field">
                                <input type="text" :placeholder="emailTxt" v-model.trim="$v.formData.email.$model">
                                <p v-if="$v.formData.email.$dirty">
                                    <span class="form-container__error-msg" v-if="!$v.formData.email.required">{{ emailRequired }}</span>
                                    <span class="form-container__error-msg" v-if="!$v.formData.email.emailValidation">{{ emailNotValid }}</span>
                                </p>
                            </div>
                            <button type="submit" class="custom-btn"> {{ submit }} </button>
                            <div class="news-letter__loader" v-if="isLoading">
                                <img src="../../../Assets/Images/spinner.svg" alt="EDA Spinner" />
                            </div>
                        </form>
                    </div>
                </div>
                <div class="toaster" v-bind:class="{'show-toaster': emailNotFound}">
                    {{ EmailMessages }}
                </div>
            </div>
        </div>
        <otp-component v-if="isEmailExist" v-on:childToParent="onChildClick" :objOtp="optPage"></otp-component>
    </section>
</template>

<script>
    import Vue from 'vue';
    import axios from 'axios';
    import otpComponent from "../Otp/OTP.vue";
    import Vuelidate from 'vuelidate';
    import { required, helpers } from 'vuelidate/lib/validators';

    Vue.use(Vuelidate);

    let baseUrl = document.location.origin;
    let apiUrl = baseUrl + "";

    const emailValidation = helpers.regex('alpha', /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/);

    export default {
        props: {
            imgDesktop: {
                type: String
            },
            imgMobile: {
                type: String
            },
            signIn: {
                type: String
            },
            objOtp: {
                type: Object
            },
            backBtn: {
                type: String
            },
            submit: {
                type: String
            },
            loginPageUrl: {
                type: String
            },
            emailTxt: {
                type: String
            },
            emailRequired: {
                type: String
            },
            emailNotValid: {
                type: String
            },
            forgetPasswordPageTitle: {
                type: String
            },
            forgetPasswordEmailConfirmation: {
                type: String
            },
            OTPScreenTitle: {
                type: String
            },
            OTPScreenConfirmEmail: {
                type: String
            },
            OTPScreenVerifyCode: {
                type: String
            },
            OTPScreenVerifyCodeRequired: {
                type: String
            },
            OTPScreenVerifyCodeNotValid: {
                type: String
            },
            newPasswordTitle: {
                type: String
            },
            newPassword: {
                type: String
            },
            formPasswordRequired: {
                type: String
            },
            formPasswordNotValid: {
                type: String
            },
            formRetypePassword: {
                type: String
            },
            formRetypePasswordRequired: {
                type: String
            },
            formRetypePasswordNotSame: {
                type: String
            },
            HomePage: {
                type: String
            },
            isForgetPasswordPage: {
                type: Boolean
            },
            homePageUrl: {
                type: String
            },
            passwordSuccessMessage: {
                type: String
            },
            login: {
                type: String
            }
        },
        components: {
            otpComponent
        },
        data() {
            return {
                forgetPasswordPageImg: this.imgDesktop,
                isEmailExist: false,
                isLoading: false,
                emailNotFound: false,
                EmailMessages: "",
                optPage: {},
                formData: {
                    email: ""
                }
            }
        },
        validations: {
            formData: {
                email: {
                    required,
                    emailValidation
                },
            }
        },
        methods: {
            onSubmit() {
                this.$v.formData.$touch();
                if (this.$v.formData.$anyError) {
                    return;
                } else {
                    this.isLoading = true;
                    let token = localStorage.getItem("token");
                    let headers = {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            'Content-Type': "application/json",
                        },
                    };
                    let formObj = {
                        email: this.formData.email
                    };
                    axios.post(
                        `${apiUrl}/Umbraco/Surface/Users/ForgetPassword`,
                        formObj,
                        headers
                    ).then(res => {
                        this.isLoading = false;
                        if (res.data === "true" || res.data.includes("نجحت")) {
                            this.optPage.userEmail = this.formData.email;
                            this.isEmailExist = true;
                        } else {
                            this.emailNotFound = true;
                            this.EmailMessages = res.data;
                            setTimeout(() => {
                                this.emailNotFound = false;
                            }, 2000);
                        }
                    }).catch(() => {});
                }

            },
            onChildClick() {
                this.$emit('childToParent', this.isEmailExist = false)
            },
            // backLogin() {
            //     this.$emit('childToParent', false)
            // }
        },
        mounted() {
            if (window.innerWidth <= 768) {
                this.forgetPasswordPageImg = this.imgMobile;
            }
            if (document.querySelector('.navbar.navbar-expand-lg')) {
                document.querySelector('.navbar.navbar-expand-lg').style.display = "none";
                document.querySelector('.breadcrumb-container').style.display = "none";
                document.querySelector('.footer').style.display = "none";
                document.querySelector('.copy-right').style.display = "none";
            }
            this.optPage = {
                imgDesktop: this.imgDesktop,
                imgMobile: this.imgMobile,
                backBtn: this.backBtn,
                userEmail: "",
                loginUrl: this.loginPageUrl,
                homeUrl: this.homePageUrl,
                isLoginPage: this.isLoginPage,
                isForgetPasswordPage: this.isForgetPasswordPage,
                OTPTitle: this.OTPScreenTitle,
                OTPConfirmEmail: this.OTPScreenConfirmEmail,
                OTPVerifyCode: this.OTPScreenVerifyCode,
                OTPVerifyCodeRequired: this.OTPScreenVerifyCodeRequired,
                OTPVerifyCodeNotValid: this.OTPScreenVerifyCodeNotValid,
                submit: this.submit,
                login: this.login,
                home: this.HomePage,
                registeredSuccess: this.registrationSuccessfully,
                passwordSuccess: this.passwordSuccessMessage,
                newPasswordTitle: this.newPasswordTitle,
                newPassword: this.newPassword,
                formPasswordRequired: this.formPasswordRequired,
                formPasswordNotValid: this.formPasswordNotValid,
                formRetypePassword: this.formRetypePassword,
                formRetypePasswordRequired: this.formRetypePasswordRequired,
                formRetypePasswordNotSame: this.formRetypePasswordNotSame
            }
        }
    }
</script>
